// MG (10/01/2026) - Attentive retired in favor of Postscript/Alia. Previous Attentive
// implementation preserved in component-email-signup-attentive-backup.js.

class EmailSignup extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      button: '[js-email-button]'
    };
  }

  connectedCallback() {
    this.button = this.querySelector(this.selectors.button);
    this.market = this.dataset.market || '';

    const campaignId =
      this.market === 'us'
        ? this.dataset.aliaCampaignIdUs || this.dataset.aliaCampaignId
        : this.dataset.aliaCampaignId;

    this.campaignId = parseInt(campaignId, 10) || null;

    if (!this.button || !this.campaignId) return;

    this.button.addEventListener('click', this._displayAliaPopup);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this._displayAliaPopup);
  }

  _displayAliaPopup = (evt) => {
    evt.preventDefault();
    window.alia = window.alia || [];
    window.alia.push({
      type: 'open',
      campaignID: this.campaignId,
      ignoreTargeting: true
    });
  };
}

customElements.define('email-signup', EmailSignup);